import apiCall from './apiCall';

const getAllEmailTemplates = async (param: any) => {
    const query = `?search=${param.search || ''}&pageNumber=${param.pageNumber}&pageSize=${param.pageSize}`;
    const URL = `/EmailTemplates/GetAllEmailTemplates${query}`;
    return apiCall('get', URL);
};

const getEmailTemplateById = async (id: string) => {
    const URL = `/EmailTemplates/GetEmailTemplateById/${id}`;
    return apiCall('get', URL);
};

const postEmailTemplate = async (data: any) => {
    const URL = '/EmailTemplates/Create';
    return apiCall('post', URL, data);
};

const putEmailTemplate = async (data: any) => {
    const URL = '/EmailTemplates/Update';
    return apiCall('post', URL, data);
};

const deleteEmailTemplate = async (data: any) => {
    const URL = '/EmailTemplates/Delete';
    return apiCall('post', URL, data);
};

export {
    getAllEmailTemplates,
    getEmailTemplateById,
    postEmailTemplate,
    putEmailTemplate,
    deleteEmailTemplate,
};
